export default __webpack_public_path__ + "static/v2-about-monica-1e8a1010a1dc788439854ba3d82f7633.png";